import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/_organization/communication/announcements/$announcementUuid"
)({
  component: function AnnouncementLayout() {
    return <Outlet />
  },
})
